/**
 * Performs a full browser reload, discarding all React state.
 *
 * Kept in its own module because `window.location` is unforgeable in jsdom and
 * cannot be stubbed, so callers are only testable when this is mockable.
 */
export const reloadWindow = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  window.location.reload();
};
